module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6761e4cfe7ec1e634d85eb1bb88e8955.png";